import { useEffect } from 'react';
import Icon from './Icon';

export default function Sheet({
  open,
  onClose,
  title,
  subtitle,
  children,
  wide = false,
  flush = false,
  className = '',
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sheet-root" role="presentation">
      <button type="button" className="sheet-backdrop" aria-label="Close" onClick={onClose} />
      <div
        className={`sheet panel-sheet ${wide ? 'wide' : ''} ${flush ? 'flush' : ''} ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className={`sheet-head ${flush ? 'is-flush' : ''}`}>
          <div>
            <h2>{title}</h2>
            {subtitle && !flush ? <p>{subtitle}</p> : null}
          </div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="Close">
            <Icon name="close" />
          </button>
        </header>
        <div className={`sheet-body ${flush ? 'is-flush' : ''}`}>{children}</div>
      </div>
    </div>
  );
}
